import dashboard from "../../assets/icons/dashboard.png";
import sitemap from "../../assets/icons/sitemap.png";
import cloudstoragedownload from "../../assets/icons/cloud-storage-download.png";
import sortbyattributes from "../../assets/icons/sort-by-attributes.png";
import fluffycloudsilhouette from "../../assets/icons/fluffy-cloud-silhouette.png";
import stackexchangelogo from "../../assets/icons/stack-exchange-logo.png";
import shapedthickmagnet from "../../assets/icons/u-shaped-thick-magnet.png";
import rsssymbol from "../../assets/icons/rss-symbol.png";
import settings from "../../assets/icons/settings.png";


import cloud from "../../assets/icons/cloud.svg";
import databaseLarge from "../../assets/icons/database-large.svg";
import databaseSmall from "../../assets/icons/database-small.svg";
import dblinks from "../../assets/icons/dblinks.svg";
import globe from "../../assets/icons/globe.svg";


const sampleImg = "data:image/png;base64,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"
const sampleImg2 = "data:image/png;base64,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"
const sampleImg3 ="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAABuCAYAAADGWyb7AAAQUElEQVR4Xu1dC3BcxZU9940kk5iUK0a20JMI1ohf0MjBwbB2JYEkFRNiJ0Yj45STkApsluUXiGayOB9wVariIIJBI9v57JJkTRGzmI81MokJwdksy6bAfPwJejJeB41MNhrZsUzi2pgA1ryb6jejj/Xr7vfejCTP6ypKLt693bfvmX6fvrfvIUzDxjXLK4DQfJA9B2SUw6Y5AOaCUAmw6fxlmPW/vQwg9LLNh4jQCxi9AP+JgD6bqM9Aps/upwOdZ8Vfm25uoKlucBYk4wMAzQfhUsD572wVux3g1FofiHZyxn6BQHtCp/He35XHe9RUJ0dqygHH71v2XpSUrgIZi8H8AQDz3bpGA7ixhrAA2gvi5+idGVs6zr75z27tyIfelAGOaxsuBmgVGJ8DUOXHZD0CN2QCowcGHiY2tnSYX93lh21e+5h04LgmuhKEVQAavU5mpL5vwJ3ccRsRbemobHrMb3t1+psU4Lh65WyU9V8POIBdpGOwjmyegBswYS8xbbFPt3/cOSv+ho5dfsgWHDiuabgGRN8EcKEfE5iojzwDlxua9wFGs2U2bc73fIb3XzDgOHxVPWAIwMQzrCCtMMBlp0LAwzC4uePMeEchJlcQ4Dgc/ToAAdqsQkxqYIxCAueMyThGoOaOqqbv5XueeQWOa6NXgh3AlD+o/JxwwYEbMv5ZBjd3mvGn/JxPQW6VHI7eDUCsNP8bIw2ivWDuA6EP4D4w9cGgPjAfgW30oeydvvOfuRwzMKM8w5lyg+w5DC4nGOUMlBNQDlA5M19EBNN/I50emy0z9q189J2XFce10UfA+KyvBjN2Arwdtr2dXn9ij599X9hz3wIiWkaMZSBa5GffAB60zNiXfO5TPFP9a1wbnQvm7QAt9Nwr83GQ8RQIOxCiHXRga8pznwod1B9OhJGhJQwsAfhKADMV1GQiv7bM2BKZkM5134Dj8IqFgP0rALN1DBhDdj/AG2CUPk6vPXbEY1+e1Bf0bphzApmrwXwbQBd46gx41S4pu3Tf3Fv+6rEfR90X4DgcFbseWz0adATEG8ClGyn12DGPffmqfnHX3bPeetdptxIEgBCRCHeNcKwfuGh/Zeyguw6GtDwDx+HGJoATHgyxAWxEibGhULdDt7aK2yhncBsIt4JhuO2HYCz0uufpCTiujV4Pxv1uJwBgM0AbKNX2koc+Cq5a19t6CbEtbp/XuB3ctrFgX3Vsr1t918BxTcOlIHrB1cDMe2DgDupq/6Ur/SmiVN+b+BSYv8ugBa5MCtGZVkXTYTe6roDj81aE0W93uRkQwA6Q/WXq2vZ/LvWnlFrk6H1n4W3jp3DeQrXbX2bg3VW7zBve1NXUBo7DK2cB/WI/7izdwQBsoVSyYHuVLuxzrRLpaXkYRCLaodeYn7Oq4h/SU3LxVsnhaBuAqO5AIPo+dbXdqq03jRTqels2EtNXtE1m3mRVxf9RR09rxXE4+q8AbtAZICd7E6WSQveUb5F0y40A/cjFRNdbZqxJVU8ZOK6NrgXjDtWOh+SMSyi19WV9vemrEUm3LARI+02ZwGs7zPgalZkrAZfb5dd+A6RUUql/FUOno0wknWBduxn8KZWogpJjORz9b+3QTL9RS38ozP6irnMKJT+/p/V8m3i/5njPWmbscpmOFLhcEFSEaDQaf4JS7f+poXDKis4/1LrctnmbzgSJ6RuyYOyEwOXSDf5HK3LN+GfqTv5Yx9BTXbauJ7GaCOpRcRFJD/FHJkqDkAAX/Q+9HBFqplRbXgKH0x3cSG/ip2Aov/KLHJYOM/b58eY9LnC5bKyfKTuM+RHqbtf/AFUeYHoLnn/ke+8pPVEmXvA0Prbpi+Nlj40JXC7vUdwiVVPoXkRJ/zI68PO+6e3e/Fqf+0wQ4JWrjcT7eCY+Mlbe5tjAZbOy1F9IiJdO9w1jNUd6l4ocav0ybP6Jak/M+HpnVeyekfLjASdyOlQzjDdTKvlFVUMCOSCSTohMgSvUfMG7LDM+KhVkFHC5XP5H1TqFDdCi6RZPU5xb3sREOIgZT6oOwExXdVY1PTFcfjRw4ahIQVA9gLGeUknl/TVVQ4tBrq4nsYkI1yrO9SHLjJ0UtD0JOOeoE5PqvuIRlBiLpnq6gaJjCi4WOdw6Hxl+HsC7pYMTToQyduR31V87MCA7ArjoOjD+RdqRECBeQ13ta5VkA6ExPRBJJ4T/lDbuGbSm02wa9PcgcNmToGUiQKpyqHA/ULJoqmVjTbffx3npe8vLOPQ8COdIbSd0WJWxwdO5Q8CFG24C6IfSDhwBvplS7W5iTmrdF5FUXW/LzcT0A5UpG4SVr1TGHndueAMKHG54CKBxt1iGdfwmOBOm7idcJbmoGFhMMpHDrRXIsMjSlj7rGLi/04w5gexhwEVfBaCSrbudUslPF5Nz8z3XSDrxCwDLFMZ52TJjlwwCx+GV7wP6X1dQFCJfo1SyRVE2EFPwQH06EWfgPgVRm068Vd5x9jf/7Kw4rRRy23g/HdyqGxxUsKl4RerT917ACIk7nryF6AqromnHAHDNAL4h1WLeQ93tH5TKBQLaHqhPt+xWS6zlOywzflcOuIYdAH1CYbS7KZUUJ0yD5rMH6tKtzQSWLx5Q0jKbGgdW3FGl41E2LaaDbTt9tjnoTpRP+uN9i2zDEDspsva6ZcbmEYdXnAvYg1spE2gdolSyUtZrcN29ByLpVlEk7kxZD3ZJWaUAbilgb5cJA/wkpdpVXlnlXQUSY3ogkm4Rp3mXSt3DdAVxbcO1YNokFQY9QKm26+RygYRbD9T1JjYRyyMGBFxDXBu9HYxREdZRgzPWUXdytVujAj25ByK9LfeA6XaZJIPjxDXRe0CQCoOwmrqS62SdBtfdeyDS03o7iKWLiEF3E4cbNwEsD+gRX0dd7Q+4NyvQlHngwj8mrjUMyB9bjH8nDjeoPRBhLKPUVuVwu8zI4PpoD9T3rl/KrPCiSPg5cTj6IgBn43LiRpcGuSUyH3m7nj1bzgKPCRsRXhDAdQOYJxOGzTV0sN1zmQfpOEUscEFvYl4JQ+Ahg65bPOP+CrC8es7x46fT4aePy7oMrrv3wPxD62badolKAZvjAXDu/ey7pi5wKYBrpFYEt0qpi7wKqN4qGTgoVpyoSvcP8kGDlxO5j7xJqL6cAHhJAPcEwJ+RDxl8Dsh95E1C+XNA7BtzOCqKq8jPbQUf4N5QUdBW/QBnwgMCOLXod7DlpeB6byKqW14gXieAiwGQJ/8Em8zeUFHQVt1kBtNqAdwXslXsZC0I68g85PW6aljHtnGdiA4sAeFp+aBBIFXuI28SqoFUImOZiMfNBUOelcxIU3dS5VyBN+uLWLuuJ9GjUpGdM3xuNlmoJtoFQljqs0zmg35XIJeOWSQCohK7QcZuhen2WWZsTi7Lq/EhgOXnBpjXUHdwtErBudoidemWOwn0Haki0S+syqbPZIGrjd4GxnqpEmMndScXS+UCAW0PRHpanlfhPGCb13RWx9dmgZsXvRwGnlEarcSoDU6hKnlKWShXpFut4q6NT1vVse25W6VT9VVwoMkrexPdSF1t/6ZsVSAo9UB9uvUGBivV8wyVcbXgbx06ZlUbfR4MBXoS2kqptqul1gQCyh6IpFsfB3iFgoJlmbF6ITf8fJw4YXqjVFlQp4RKayabhUNq5zQRcNhEOCOi3vJgNmizZTY5NWWGgKtpvBrEiryfdAul2hSPHU8TD06SmZHexE1gqPmScLNVGXOOcJ9cdSEcfQWAsxQnbvwaSjKLg9pdMj9NfF1Qv7z9rrKdSrw9jB7qn1E/QGs9ss7JnWCFb4ks5N+lruSd3kwvbu26dOudBJZ/u2X9fa9VGRtMXB654s4DYAEoVXDpm2BjMXVvFas0aJoeyH0CiCNrSiRLI/l4xioJJSIFImKg0PgBSrUHB0EUPDVSJJJOtAL4qqJqm2XGTnrrHKMIW+NykEYN4aDkoaLvh8Sc3BLwTlVGLCL67EjC+PHKHop6XhcrWvQ0pZKfVJQNxCDKHrb8TIMJa69lxkaRLo0NXG3DajBpFH+mf6LuNpG7EjSJB3RLHo5XEd2v0r7/D5uX08F2tf3OIoVXMF/R27RNrbqCcJJmaV9HpabhGhCpF9MGDqCk/0PBt934v8pIOiEyDTToyjSLaQ8MzWHN8vWMZ6g7+bEiXVATTluXpsx1+Xpn1YWvqgcMPcII4GFKJeVB2SJCV5uezCthRBY8zYrojhLdQd1tdxURNuNO1Q0tmWeKlmG3TH1SJLYvo+5tYrUWbXNJR+YPKZKzgGqjV4IR0JBp/gQnnYYse8tsvAtg/TpeRUhH5pJ+TLi52TJjStxE43LrjPXj4tqGB8HkghyieGjJ3NCO5Xz9oGXGvqS6qLWAy72s/AaA/it/EdCTadONDaH0a8uMaXzfuWAlzoH3vwBECEiznZo0ZQ5TVX9Zqw7N2DDHvWqZMVXyqUE17RWXBc7JCkurFIAehSzzIyjNfOVU2WHJvTmKEI0GvVjOK4Rjdqiset/cW1QO7J/kSlfAZd80l58DDv1ec8kNiL8I4m9PdwasHDOVYP1SpBU72Vv9hJr9lTFXJUhcA+eAN69xEQyHZsRt2wzQhulW+Ca3wy84hRQZqUa7Z2REW9eBnoDLPe/Es04889w2G8BGlBgbpnqGtODD4X6OaZAZjekT28aCfdWxvW4dJvQ8A+eAd87KObD7Bb1LhQdjjoB4A7h041SjfnGoVBASK0yc3pUSO0zgg78gRBdYFU3yY20SR/oCXPa2ee1poGO/BOGjHsATqvsBAaDdNtlsIoKFg217BdkUU+K/mWjizM/NoJlLdpk3vOnRP466b8ANGKNcxUFuvZjgfwH4DWzjyUJxHQgOACC0lIGP575Xvayw7CyZN1lVcXllC7lPBiV8By733NPJYFIzl3kPiH4Fm7b5XYldVCDPGKGrDNifVI9Oq5kNYL1lxnwnR8wLcA54NY3fAXG+EmYPAdgFOEeg/wTQYTCOgvAGbByFQUfxtv3G+1+4BFQ2c3bpO/1n2DDOgIHZDJwBUAURiyPUFQBdrFJ5XBmmYYIEXtthxte40ZXp5A04B7xsVEFsTF8mMyQf1+t/OynDiqk8y+DmTjP+VD7mlZdn3FiG5oKxAsBZ+ZrIWP0WHDgRuQY1d1Q1qWfIuXRIXlfccJtyaRACvM+5tFVbrZDAiRwRGNzccWZcfBblvRUMuMG3zmz2mABQe2NV1xuFAY73AUazZTYpFPnRncH48gUHznn2Va+cjbL+6wGs0iCK1551foHjXcz0KE7nn3TOiotj2AVtkwLcSbfQmuhKkAOgKve4soN8B45wAoxHBWAjCdWVjfJJcNKBG7yFCg5y0Cqw8wz0pYKRb8AROgRYJXbm0eFc3D5h4KqbKQPcIIAOrXWpWIEfBkiQDKrwto45eQ/AiY3v3QzsDhF2DDABu/JwnpSmHHAj55njb12Y5UbghTkwZ6v4QwO41wHaDdgvI2S8RG/97WXBQ6oyxmTJTHngxnJMlvOOzwN4bi4iMRfgCsDI/YXz/3PAiV2VwyCI3Zbsv43cX/Bhu2TGK/vm3iKuTav2dw4t0ahA4h7gAAAAAElFTkSuQmCC"

export const staticGraphList = {
    nodes: [
      { id: 1, label: "Node 1", 
      x:-180,
      y:380,
      margin: 30,
      borderWidth: 6,
      borderWidthSelected: 6,
      color:  {
        background : "#f8f9ff",
        border: "#2ce68f",
        highlight : {
          background : " #f8f9ff",
          border: "#2ce68f",
        },
       hover : {
        background : " #f8f9ff",
        border: "#2ce68f",
       },
      },
       shape: "circularImage",
      image: cloudstoragedownload,
      size: 24,
      shapeProperties: { useImageSize: true },
      imagePadding: 2,
      widthMin: 20,
      widthMax: 20,
        font : {
          size : 16,
          align : "center",
          vadjust : 16
        },
      shadow: {
        color: "#ff2251",
        enabled: true,
          size: 16,
          x: 0,
          y:0,
        },
        
      },
      { id: 2,
        x:50,
        y:50,
        size: 60,
        shape: "circularImage",
        image: settings,
        label: "JAVA DB",
        widthMin: 36,
        widthMax: 36,
        borderWidth: 12,
        borderWidthSelected: 10,
        shapeProperties: { useImageSize: true },
        color:  {
          background : "#f8f9ff",
          border: "#ff2251",
          highlight : {
            background : " #f8f9ff",
            border: "#ff2251",
          },
         hover : {
          background : " #f8f9ff",
          border: "#ff2251",
         },},
         font : {
          size : 16,
          align : "center",
          vadjust : 48
        },
      shadow: {
        color: "#ff2251",
        enabled: true,
          size: 40,
          x: 0,
          y:0,
        },
    },
      { id: 3, label: "Node 3",
      x:-328,
      y:40,
      borderWidth: 6,
      borderWidthSelected: 6,
      color:  {
        background : "#f8f9ff",
        border: "#ff2251",
        highlight : {
          background : " #f8f9ff",
          border: "#2ce68f",
        },
       hover : {
        background : " #f8f9ff",
        border: "#2ce68f",
       },},
       shape: "circularImage",
        image: sortbyattributes,
        size: 24,
        shapeProperties: { useImageSize: true },
        imagePadding: 0,
        widthMin: 14,
        widthMax: 14,
        shadow: {
          color: "#ff2251",
          enabled: true,
            size: 16,
            x: 0,
            y:0,
          },
        font : {
          size : 16,
          align : "center",
          vadjust : 16
        },
      },
      { id: 4, label: "Node 4",
      x:50,
      y:-208,
      borderWidth: 6,
      borderWidthSelected: 6,
      color:  {
        background : "#f8f9ff",
        border: "#f8f9ff",
        highlight : {
          background : " #f8f9ff",
          border: "#f8f9ff",
        },
       hover : {
        background : " #f8f9ff",
        border: "#f8f9ff",
       },},
       shape: "circularImage",
        image: rsssymbol,
        size: 24,
        font : {
          size : 16,
          align : "center",
          vadjust : 16
        },
        shapeProperties: { useImageSize: true },
        imagePadding: 2,
        widthMin: 14,
        widthMax: 14,
    },
      { id: 5, label: "Node 5", size: 24,
      font : {
        size : 16,
        align : "center",
        vadjust : 16
      },
      x:378,
      y:-62,
      shape: "circularImage",
      image: shapedthickmagnet,
      size: 24,
      font : {
        size : 16,
        align : "center",
        vadjust : 16
      },
      shapeProperties: { useImageSize: true },
      imagePadding: 2,
      widthMin: 14,
      widthMax: 14,
      borderWidth:6,
      color: {  
        border: "#b8b7d0",
        background: "#f8f9ff",
        highlight: { border: "orange", background: "#CCC" },
        hover: { border: "orange", background: "grey" },
      },
      },
      {
        id:"6",
        x:243,
      y:-189,
        shape: "circularImage",
        image: dashboard,
        label: "Node 6",
        size: 24,
        font : {
          size : 16,
          align : "center",
          vadjust : 16
        },
        shapeProperties: { useImageSize: true },
        imagePadding: 2,
        widthMin: 14,
        widthMax: 14,
        borderWidth:6,
        color: {  
          border: "#b8b7d0",
          background: "#f8f9ff",
          highlight: { border: "orange", background: "#CCC" },
          hover: { border: "orange", background: "grey" },
        },
        },
      { id: 7, label: "Database", 
      x:-360,
      y:-100,
      borderWidth: 6,
      borderWidthSelected: 6,
      color:  {
        background : "#f8f9ff",
        border: "#2ce68f",
        highlight : {
          background : " #f8f9ff",
          border: "#2ce68f",
        },
       hover : {
        background : " #f8f9ff",
        border: "#2ce68f",
       },},
       shape: "circularImage",
        image: cloudstoragedownload,
        size: 24,
        font : {
          size : 16,
          align : "center",
          vadjust : 16
        },
        shapeProperties: { useImageSize: true },
        imagePadding: 2,
        widthMin: 14,
        widthMax: 14,
      },
      { id: 8, label: "Mongo DB",
      x:530,
      y:-120,
    
      margin: { top: 260, right: 20, bottom: 30, left: -20 },
      borderWidth: 10,
      borderWidthSelected: 10,
      color:  {
        background : "#f8f9ff",
        border: "#ff2251",
        highlight : {
          background : " #f8f9ff",
          border: "#ff2251",
        },
       hover : {
        background : " #f8f9ff",
        border: "#ff2251",
       },},
       shape: "circularImage",
        image: settings,
        size: 40,
        shapeProperties: { useImageSize: true },
        imagePadding: { left: 100, top: 60, right: 8, bottom: 60 },
        widthMin: 40,
        widthMax: 40,
        shadow: {
          color: "#ff2251",
          enabled: true,
            size: 32,
            x: 0,
            y:0,
          },
          font : {
            size : 16,
            align : "center",
            vadjust : 24
          },
    },
      { id: 9, label: "Node JS",
      x:400,
      y:240,
      borderWidth: 6,
      borderWidthSelected: 6,
      color:  {
        background : "#f8f9ff",
        border: "#ff2251",
        highlight : {
          background : " #f8f9ff",
          border: "#2ce68f",
        },
       hover : {
        background : " #f8f9ff",
        border: "#2ce68f",
       },},
       shape: "circularImage",
        image: sortbyattributes,
        size: 24,
        font : {
          size : 16,
          align : "center",
          vadjust : 16
        },
        shapeProperties: { useImageSize: true },
        imagePadding: 0,
        widthMin: 14,
        widthMax: 14, },
      { id: 10, label: "React",
      x:50,
      y:350,
      borderWidth: 6,
      borderWidthSelected: 6,
      color:  {
        background : "#b8b7d0",
        border: "#f8f9ff",
        highlight : {
          background : " #b8b7d0",
          border: "#f8f9ff",
        },
       hover : {
        background : " #b8b7d0",
        border: "#f8f9ff",
       },},
       shape: "circularImage",
        image: rsssymbol,
        size: 24,
        font : {
          size : 16,
          align : "center",
          vadjust : 16
        },
        shapeProperties: { useImageSize: true },
        imagePadding: 2,
        widthMin: 14,
        widthMax: 14,
    },
      { id: 11, label: "SQL",
      x:360,
      y:-310,
      shape: "circularImage",
      image: shapedthickmagnet,
      size: 24,
      font : {
        size : 16,
        align : "center",
        vadjust : 16
      },
      shapeProperties: { useImageSize: true },
      imagePadding: 2,
      widthMin: 14,
      widthMax: 14,
      borderWidth:6,
      color: {  
        border: "#b8b7d0",
        background: "#f8f9ff",
        highlight: { border: "orange", background: "#CCC" },
        hover: { border: "orange", background: "grey" },
      },
      },
      {
        id:12,
        x:710,
        y:-180,
        shape: "circularImage",
        image: dashboard,
        label: "JAVA DB",
        size: 24,
        font : {
          size : 16,
          align : "center",
          vadjust : 16
        },
        shapeProperties: { useImageSize: true },
        imagePadding: { left: 2, top: 10, right: 8, bottom: 20 },
        widthMin: 14,
        widthMax: 14,
        borderWidth:6,
        color: {  
          border: "#b8b7d0",
          background: "#f8f9ff",
          highlight: { border: "orange", background: "#CCC" },
          hover: { border: "orange", background: "grey" },
        },
        },
        {
          id:13,
          x:760,
          y:560,
          shape: "circularImage",
          image: dashboard,
          label: "Python",
          size: 40,
          shapeProperties: { useImageSize: true },
          imagePadding: { left: 2, top: 10, right: 8, bottom: 20 },
          widthMin: 14,
          widthMax: 14,
          borderWidth:10,
          color: {  
            border: "#2ce68f",
            background: "#f8f9ff",
            highlight: { border: "orange", background: "#CCC" },
            hover: { border: "orange", background: "grey" },
          },
          font : {
            size : 16,
            align : "center",
            vadjust : 30
          },
          },
          {
            id:14,
    
            x:-360,
            y:660,
            shape: "circularImage",
            image: sitemap,
            label: "Monitor",
            size: 40,
            shapeProperties: { useImageSize: true },
            imagePadding: { left: 2, top: 10, right: 8, bottom: 20 },
            widthMin: 14,
            widthMax: 14,
            borderWidth:10,
            color: {  
              border: "#2ce68f",
              background: "#f8f9ff",
              highlight: { border: "orange", background: "#CCC" },
              hover: { border: "orange", background: "grey" },
            },
            font : {
              size : 16,
              align : "center",
              vadjust : 30
            },
            },
            {
              id:15,
              x:-460,
              y:460,
              shape: "circularImage",
              image: dashboard,
              label: "Node M",
              size: 32,
              shapeProperties: { useImageSize: true },
              imagePadding: { left: 2, top: 40, right: 8, bottom: 20 },
              widthMin: 14,
              widthMax: 14,
              borderWidth:10,
              color: {  
                border: "#b8b7d0",
                background: "#f8f9ff",
                highlight: { border: "orange", background: "#CCC" },
                hover: { border: "orange", background: "grey" },
              },
              font : {
                size : 16,
                align : "center",
                vadjust : 24
              },
              },
              {
                id:16,
                x:-840,
                y:-50,
                shape: "circularImage",
                image: fluffycloudsilhouette,
                label: "Database",
                size: 24,
                shapeProperties: { useImageSize: true },
                imagePadding: { left: 2, top: 40, right: 8, bottom: 20 },
                widthMin: 14,
                widthMax: 14,
                borderWidth:6,
                color: {  
                  border: "#b8b7d0",
                  background: "#f8f9ff",
                  highlight: { border: "orange", background: "#CCC" },
                  hover: { border: "orange", background: "grey" },
                },
                font : {
                  size : 16,
                  align : "center",
                  vadjust : 16
                },
                },
  
                {
                  id:17,
                  x:-900,
                  y:-160,
                  shape: "circularImage",
                  image: databaseSmall,
                  label: "RDBMS",
                  size: 24,
                  shapeProperties: { useImageSize: true },
                  imagePadding: { left: 2, top: 40, right: 8, bottom: 20 },
                  widthMin: 14,
                  widthMax: 14,
                  borderWidth:6,
                  color: {  
                    border: "#2ce68f",
                    background: "#f8f9ff",
                    highlight: { border: "orange", background: "#CCC" },
                    hover: { border: "orange", background: "grey" },
                  },
                  font : {
                    size : 16,
                    align : "center",
                    vadjust : 16
                  },
                  },
                  {
                    id:18,
                    x:-840,
                    y:-260,
                    shape: "circularImage",
                    image: dashboard,
                    label: "Flow X",
                    size: 24,
                    shapeProperties: { useImageSize: true },
                    imagePadding: { left: 2, top: 40, right: 8, bottom: 20 },
                    widthMin: 14,
                    widthMax: 14,
                    borderWidth:6,
                    color: {  
                      border: "#ff2251",
                      background: "#f8f9ff",
                      highlight: { border: "orange", background: "#CCC" },
                      hover: { border: "orange", background: "grey" },
                    },
                    font : {
                      size : 16,
                      align : "center",
                      vadjust : 16
                    },
                    },
                    {
                      id:19,
                      x:-560,
                      y:-160,
                      shape: "circularImage",
                      image: stackexchangelogo,
                      label: "Q Lang",
                      size: 40,
                      shapeProperties: { useImageSize: true },
                      imagePadding: { left: 2, top: 40, right: 8, bottom: 20 },
                      widthMin: 14,
                      widthMax: 14,
                      borderWidth:10,
                      color: {  
                        border: "#b8b7d0",
                        background: "#f8f9ff",
                        highlight: { border: "orange", background: "#CCC" },
                        hover: { border: "orange", background: "grey" },
                      },
                      font : {
                        size : 16,
                        align : "center",
                        vadjust : 30
                      },
                      shadow: {
                        color: "#ff2251",
                        enabled: true,
                          size: 32,
                          x: 0,
                          y:0,
                        },
                      },
                      
                      {
                        id:20,
                        x:-260,
                        y:-360,
                        shape: "circularImage",
                        image: shapedthickmagnet,
                        label: "Node Arc",
                        size: 48,
                        shapeProperties: { useImageSize: true },
                        borderWidth:0,
                        color: {  
                          border: "#b8b7d0",
                          background: "#f8f9ff",
                          highlight: { border: "orange", background: "#CCC" },
                          hover: { border: "orange", background: "grey" },
                        },
                        font : {
                          size : 16,
                          align : "center",
                          vadjust : 40
                        },
                        
                        shadow: {
                          color: "#ff2251",
                          enabled: true,
                            size: 32,
                            x: 0,
                            y:0,
                          },
                        },
                        {
                          id:21,
                          x:-260,
                          y:-360,
                          shape: "circularImage",
                          image: sampleImg,
                          label: "",
                          size: 56,
                          shapeProperties: { useImageSize: true },
                          borderWidth:0,
                          color: {  
                            border: "transparent",
                            background: "transparent",
                            highlight: { border: "transparent", background: "transparent" },
                            hover: { border: "transparent", background: "transparent" },
                          },
                          },
  
                          {
                            id:25,
                            x:-460,
                            y:-560,
                            shape: "circularImage",
                            image: dashboard,
                            label: "Node X",
                            size: 48,
                            shapeProperties: { useImageSize: true },
                            borderWidth:0,
                            color: {  
                              border: "#b8b7d0",
                              background: "#f8f9ff",
                              highlight: { border: "orange", background: "#CCC" },
                              hover: { border: "orange", background: "grey" },
                            },
                            font : {
                              size : 16,
                              align : "center",
                              vadjust : 40
                            },
                            
                            shadow: {
                              color: "#ff2251",
                              enabled: true,
                                size: 32,
                                x: 0,
                                y:0,
                              },
                            },
                          
                          {
                            id:22,
                            x:-460,
                            y:-560,
                            shape: "circularImage",
                            image: sampleImg2,
                            label: "",
                            size: 56,
                            shapeProperties: { useImageSize: true },
                            borderWidth:0,
                            color: {  
                              border: "transparent",
                              background: "transparent",
                              highlight: { border: "transparent", background: "transparent" },
                              hover: { border: "transparent", background: "transparent" },
                            },
                            },
                              {
                                id:28,
                                x:-760,
                              y:-660,
                                shape: "circularImage",
                                image: fluffycloudsilhouette,
                                label: "Database X",
                                size: 44,
                                shapeProperties: { useImageSize: true },
                                imagePadding: { left: 2, top: 40, right: 8, bottom: 20 },
                                widthMin: 14,
                                widthMax: 14,
                                borderWidth:0,
                                color: {  
                                  border: "#b8b7d0",
                                  background: "#f8f9ff",
                                  highlight: { border: "orange", background: "#CCC" },
                                  hover: { border: "orange", background: "grey" },
                                },
                                font : {
                                  size : 16,
                                  align : "center",
                                  vadjust : 42
                                },
                                },
    ],
    edges: [{ from: 1, to: 2,
      color : {
        color: "#ff2251",
      },
      arrows : {
        to: {
          scaleFactor : 1}},
      dashes: true,
      width : 3}, 
      { from: 1, to: 3 }, { from: 2, to: 4 }, { from: 2, to: 5 }, { from: 6, to: 5 },
      { from: 2, to: 10 },
      { from: 7, to: 9 },
      { from: 11, to: 8 },
      { from: 12, to: 8,
        color : {
          color: "#BBB",
        },
        arrows : {
          to: {
            scaleFactor : 1}},
        dashes: true, width : 3},
      { from: 14, to: 15, dashes: true },
      { from: 8, to: 13,
      
        color : {
          color: "#ff2251",
        },
        arrows : {
          to: {
            scaleFactor : 1}},
        dashes: true, width : 3},
        { from: 13, to: 14,
          color : {
            color: "#b8b7d0",
          },
          arrows : {
            to: {
              }},
          dashes: true, width : 3},
          { from: 16, to: 19 },
          { from: 17, to: 19,
            color : {
              color: "#ff2251",
            },
            arrows : {
              to: {
                scaleFactor : 1}},
            dashes: true,
                width: 3
          },
          { from: 18, to: 19 },
          
          { from: 21, to: 19 },
          { from: 22, to: 2 },  
    ]
  };

  export const staticGraphOptions = {
    edges: {
      font: {
        size: 16,
      },
      physics: false,
      selfReferenceSize: 30,
    },
    nodes: {
      shape: "box",
      widthConstraint: 250,
      color: "#cccccc",
      margin: 10,
      font: {
        size: 16,
      },
      physics: false,
    },
    physics:{
      enabled: false,
    },
    //   barnesHut: {
    //     //theta: 0.5,
    //     gravitationalConstant: -2000,
    //     centralGravity: 0.3,
    //     springLength: 95,
    //     springConstant: 0.04,
    //     damping: 0.09,
    //     avoidOverlap: 1
    //   },
    //   forceAtlas2Based: {
    //     //theta: 0.5,
    //     gravitationalConstant: -50,
    //     centralGravity: 0.01,
    //     springConstant: 0.08,
    //     springLength: 100,
    //     damping: 0.4,
    //     avoidOverlap: 1
    //   },
    //   repulsion: {
    //     centralGravity: 0.4,
    //     springLength: 500,
    //     springConstant: 0.5,
    //     nodeDistance: 500,
    //     damping: 0.09
    //   },
    //   hierarchicalRepulsion: {
    //     centralGravity: 0.3,
    //     springLength: 100,
    //     springConstant: 0.01,
    //     nodeDistance: 400,
    //     damping: 0.09,
    //     avoidOverlap: 1
    //   },
    //   maxVelocity: 50,
    //   minVelocity: 0.1,
    //   solver: 'barnesHut',
    //   stabilization: {
    //     enabled: true,
    //     iterations: 1000,
    //     updateInterval: 100,
    //     onlyDynamicEdges: false,
    //     fit: true
    //   },
    //   timestep: 0.5,
    //   adaptiveTimestep: true,
    //   wind: { x: 0, y: 0 }
    // },
    interaction: {
      hover: true,
    }
};



export const staticGraphApiList = {
    "nodes": [
        {
            "id": "55c3b37d-125b-416e-a024-f1d3ef5981ad",
            "applicationId": "fb8012cd-9625-4ba7-a0b2-f34b88b76e25",
            "serviceId": "5470daff-caaf-493b-853a-e5d9eea92937",
            "name": "Node1",
            "type": {
                "code": "APPLICATION",
                "value": "Application"
            },
            "subType": {
                "code": "MONOLITHIC",
                "type": {
                    "code": "APPLICATION",
                    "value": "Application"
                },
                "value": "Monolithic Application"
            },
            "metrics": {
                "countOfSources": 2,
                "countOfTargets": 4,
                "alerts": {
                    "count": 44,
                    "countBySeverity": {
                        "MEDIUM": 20,
                        "HIGH": 10,
                        "LOW": 14
                    }
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "04cfb84d-289f-4354-839a-458453e3b486",
            "applicationId": "fb8012cd-9625-4ba7-a0b2-f34b88b76e25",
            "serviceId": "5470daff-caaf-493b-853a-e5d9eea92937",
            "name": "Node3",
            "type": {
                "code": "APPLICATION",
                "value": "Application"
            },
            "subType": {
                "code": "MONOLITHIC",
                "type": {
                    "code": "APPLICATION",
                    "value": "Application"
                },
                "value": "Monolithic Application"
            },
            "metrics": {
                "countOfSources": 2,
                "countOfTargets": 2,
                "alerts": {
                    "count": 12,
                    "countBySeverity": {
                        "HIGH": 5,
                        "MEDIUM": 7
                    }
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "a05b51b2-3e44-4c65-8bbf-30516c8e3254",
            "applicationId": "4b36d1dd-0212-4a3d-b5d3-1589933c406c",
            "serviceId": "065f67f8-4771-4382-9ae0-318bd81f3cb9",
            "name": "Node5",
            "type": {
                "code": "APPLICATION",
                "value": "Application"
            },
            "subType": {
                "code": "MONOLITHIC",
                "type": {
                    "code": "APPLICATION",
                    "value": "Application"
                },
                "value": "Monolithic Application"
            },
            "metrics": {
                "countOfSources": 2,
                "countOfTargets": 4,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "52a443d1-1a90-4c93-91e7-839ae4690c9c",
            "applicationId": "4b36d1dd-0212-4a3d-b5d3-1589933c406c",
            "serviceId": "065f67f8-4771-4382-9ae0-318bd81f3cb9",
            "name": "Node6",
            "type": {
                "code": "DATASOURCE",
                "value": "Datasource"
            },
            "subType": {
                "code": "SQL SERVER",
                "type": {
                    "code": "DATASOURCE",
                    "value": "Datasource"
                },
                "value": "SQL Server Database"
            },
            "metrics": {
                "countOfSources": 1,
                "countOfTargets": 0,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "63786797-f479-413b-9c28-ca323f5ff75a",
            "applicationId": "4b36d1dd-0212-4a3d-b5d3-1589933c406c",
            "serviceId": "065f67f8-4771-4382-9ae0-318bd81f3cb9",
            "name": "Node7",
            "type": {
                "code": "APPLICATION",
                "value": "Application"
            },
            "subType": {
                "code": "MONOLITHIC",
                "type": {
                    "code": "APPLICATION",
                    "value": "Application"
                },
                "value": "Monolithic Application"
            },
            "metrics": {
                "countOfSources": 1,
                "countOfTargets": 1,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "08cbe0e3-daf0-457d-8693-f884e0182916",
            "applicationId": "4b36d1dd-0212-4a3d-b5d3-1589933c406c",
            "serviceId": "065f67f8-4771-4382-9ae0-318bd81f3cb9",
            "name": "Node8",
            "type": {
                "code": "DATASOURCE",
                "value": "Datasource"
            },
            "subType": {
                "code": "SQL SERVER",
                "type": {
                    "code": "DATASOURCE",
                    "value": "Datasource"
                },
                "value": "SQL Server Database"
            },
            "metrics": {
                "countOfSources": 2,
                "countOfTargets": 2,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "35042889-f55b-4bc8-b1ef-93779d2d8163",
            "applicationId": "fb8012cd-9625-4ba7-a0b2-f34b88b76e25",
            "serviceId": "5470daff-caaf-493b-853a-e5d9eea92937",
            "name": "Node9",
            "type": {
                "code": "APPLICATION",
                "value": "Application"
            },
            "subType": {
                "code": "MONOLITHIC",
                "type": {
                    "code": "APPLICATION",
                    "value": "Application"
                },
                "value": "Monolithic Application"
            },
            "metrics": {
                "countOfSources": 2,
                "countOfTargets": 2,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "106a5d9d-d2e3-4ba8-b5d1-0d80c7a0657f",
            "applicationId": "fb8012cd-9625-4ba7-a0b2-f34b88b76e25",
            "serviceId": "5470daff-caaf-493b-853a-e5d9eea92937",
            "name": "Node10",
            "type": {
                "code": "DATASOURCE",
                "value": "Datasource"
            },
            "subType": {
                "code": "POSTGRESQL",
                "type": {
                    "code": "DATASOURCE",
                    "value": "Datasource"
                },
                "value": "PostgreSQL Database"
            },
            "metrics": {
                "countOfSources": 0,
                "countOfTargets": 1,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "b8ecd1b5-0236-4c42-9029-b2b29572711d",
            "applicationId": "fb8012cd-9625-4ba7-a0b2-f34b88b76e25",
            "serviceId": "5470daff-caaf-493b-853a-e5d9eea92937",
            "name": "Node11",
            "type": {
                "code": "APPLICATION",
                "value": "Application"
            },
            "subType": {
                "code": "MONOLITHIC",
                "type": {
                    "code": "APPLICATION",
                    "value": "Application"
                },
                "value": "Monolithic Application"
            },
            "metrics": {
                "countOfSources": 3,
                "countOfTargets": 3,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "04323b01-d56b-487d-a87a-d66577434bc8",
            "applicationId": "fb8012cd-9625-4ba7-a0b2-f34b88b76e25",
            "serviceId": "5470daff-caaf-493b-853a-e5d9eea92937",
            "name": "Node12",
            "type": {
                "code": "DATASOURCE",
                "value": "Datasource"
            },
            "subType": {
                "code": "POSTGRESQL",
                "type": {
                    "code": "DATASOURCE",
                    "value": "Datasource"
                },
                "value": "PostgreSQL Database"
            },
            "metrics": {
                "countOfSources": 1,
                "countOfTargets": 0,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "52a5936d-194e-4cc1-8157-9fd2d8c4194a",
            "applicationId": "4b36d1dd-0212-4a3d-b5d3-1589933c406c",
            "serviceId": "065f67f8-4771-4382-9ae0-318bd81f3cb9",
            "name": "Node13",
            "type": {
                "code": "APPLICATION",
                "value": "Application"
            },
            "subType": {
                "code": "MONOLITHIC",
                "type": {
                    "code": "APPLICATION",
                    "value": "Application"
                },
                "value": "Monolithic Application"
            },
            "metrics": {
                "countOfSources": 1,
                "countOfTargets": 0,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "cc01b36f-5b73-4962-8720-0837f02d5bcc",
            "applicationId": "4b36d1dd-0212-4a3d-b5d3-1589933c406c",
            "serviceId": "065f67f8-4771-4382-9ae0-318bd81f3cb9",
            "name": "Node14",
            "type": {
                "code": "DATASOURCE",
                "value": "Datasource"
            },
            "subType": {
                "code": "SQL SERVER",
                "type": {
                    "code": "DATASOURCE",
                    "value": "Datasource"
                },
                "value": "SQL Server Database"
            },
            "metrics": {
                "countOfSources": 1,
                "countOfTargets": 1,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "a5158bcc-e29e-4029-a61a-2ebaf4ecf141",
            "applicationId": "4b36d1dd-0212-4a3d-b5d3-1589933c406c",
            "serviceId": "065f67f8-4771-4382-9ae0-318bd81f3cb9",
            "name": "Node16",
            "type": {
                "code": "DATASOURCE",
                "value": "Datasource"
            },
            "subType": {
                "code": "SQL SERVER",
                "type": {
                    "code": "DATASOURCE",
                    "value": "Datasource"
                },
                "value": "SQL Server Database"
            },
            "metrics": {
                "countOfSources": 1,
                "countOfTargets": 0,
                "alerts": {
                    "count": 0,
                    "countBySeverity": null
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "155c01d3-b1de-4d80-b6d1-8a9bcb6b6d7c",
            "applicationId": "4b36d1dd-0212-4a3d-b5d3-1589933c406c",
            "serviceId": "065f67f8-4771-4382-9ae0-318bd81f3cb9",
            "name": "Node17",
            "type": {
                "code": "APPLICATION",
                "value": "Application"
            },
            "subType": {
                "code": "MONOLITHIC",
                "type": {
                    "code": "APPLICATION",
                    "value": "Application"
                },
                "value": "Monolithic Application"
            },
            "metrics": {
                "countOfSources": 1,
                "countOfTargets": 1,
                "alerts": {
                    "count": 8,
                    "countBySeverity": {
                        "MEDIUM": 1,
                        "LOW": 7
                    }
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        },
        {
            "id": "dc03c89c-f462-43b2-b8d3-0f6d7689884f",
            "applicationId": "4b36d1dd-0212-4a3d-b5d3-1589933c406c",
            "serviceId": "065f67f8-4771-4382-9ae0-318bd81f3cb9",
            "name": "Node18",
            "type": {
                "code": "DATASOURCE",
                "value": "Datasource"
            },
            "subType": {
                "code": "SQL SERVER",
                "type": {
                    "code": "DATASOURCE",
                    "value": "Datasource"
                },
                "value": "SQL Server Database"
            },
            "metrics": {
                "countOfSources": 1,
                "countOfTargets": 0,
                "alerts": {
                    "count": 22,
                    "countBySeverity": {
                        "HIGH": 5,
                        "LOW": 7,
                        "MEDIUM": 10
                    }
                },
                "traces": {
                    "count": 0
                }
            },
            "edge": {
                "uiConfiguration": null
            }
        }
    ],
    "hierarchy": {
        "55c3b37d-125b-416e-a024-f1d3ef5981ad": {
            "sources": [
                {
                    "id": "a05b51b2-3e44-4c65-8bbf-30516c8e3254",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "106a5d9d-d2e3-4ba8-b5d1-0d80c7a0657f",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": [
                {
                    "id": "04cfb84d-289f-4354-839a-458453e3b486",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "52a443d1-1a90-4c93-91e7-839ae4690c9c",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "08cbe0e3-daf0-457d-8693-f884e0182916",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "b8ecd1b5-0236-4c42-9029-b2b29572711d",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ]
        },
        "04cfb84d-289f-4354-839a-458453e3b486": {
            "sources": [
                {
                    "id": "55c3b37d-125b-416e-a024-f1d3ef5981ad",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "a05b51b2-3e44-4c65-8bbf-30516c8e3254",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": [
                {
                    "id": "a05b51b2-3e44-4c65-8bbf-30516c8e3254",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "08cbe0e3-daf0-457d-8693-f884e0182916",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ]
        },
        "a05b51b2-3e44-4c65-8bbf-30516c8e3254": {
            "sources": [
                {
                    "id": "04cfb84d-289f-4354-839a-458453e3b486",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "63786797-f479-413b-9c28-ca323f5ff75a",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": [
                {
                    "id": "63786797-f479-413b-9c28-ca323f5ff75a",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "55c3b37d-125b-416e-a024-f1d3ef5981ad",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "04cfb84d-289f-4354-839a-458453e3b486",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "b8ecd1b5-0236-4c42-9029-b2b29572711d",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ]
        },
        "63786797-f479-413b-9c28-ca323f5ff75a": {
            "sources": [
                {
                    "id": "a05b51b2-3e44-4c65-8bbf-30516c8e3254",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": [
                {
                    "id": "a05b51b2-3e44-4c65-8bbf-30516c8e3254",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ]
        },
        "52a443d1-1a90-4c93-91e7-839ae4690c9c": {
            "sources": [
                {
                    "id": "55c3b37d-125b-416e-a024-f1d3ef5981ad",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": []
        },
        "08cbe0e3-daf0-457d-8693-f884e0182916": {
            "sources": [
                {
                    "id": "55c3b37d-125b-416e-a024-f1d3ef5981ad",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "04cfb84d-289f-4354-839a-458453e3b486",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": [
                {
                    "id": "35042889-f55b-4bc8-b1ef-93779d2d8163",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "04323b01-d56b-487d-a87a-d66577434bc8",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ]
        },
        "35042889-f55b-4bc8-b1ef-93779d2d8163": {
            "sources": [
                {
                    "id": "08cbe0e3-daf0-457d-8693-f884e0182916",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "b8ecd1b5-0236-4c42-9029-b2b29572711d",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": [
                {
                    "id": "b8ecd1b5-0236-4c42-9029-b2b29572711d",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "cc01b36f-5b73-4962-8720-0837f02d5bcc",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ]
        },
        "b8ecd1b5-0236-4c42-9029-b2b29572711d": {
            "sources": [
                {
                    "id": "35042889-f55b-4bc8-b1ef-93779d2d8163",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "a05b51b2-3e44-4c65-8bbf-30516c8e3254",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "55c3b37d-125b-416e-a024-f1d3ef5981ad",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": [
                {
                    "id": "52a5936d-194e-4cc1-8157-9fd2d8c4194a",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "35042889-f55b-4bc8-b1ef-93779d2d8163",
                    "edge": {
                        "uiConfiguration": null
                    }
                },
                {
                    "id": "155c01d3-b1de-4d80-b6d1-8a9bcb6b6d7c",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ]
        },
        "52a5936d-194e-4cc1-8157-9fd2d8c4194a": {
            "sources": [
                {
                    "id": "b8ecd1b5-0236-4c42-9029-b2b29572711d",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": []
        },
        "04323b01-d56b-487d-a87a-d66577434bc8": {
            "sources": [
                {
                    "id": "08cbe0e3-daf0-457d-8693-f884e0182916",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": []
        },
        "cc01b36f-5b73-4962-8720-0837f02d5bcc": {
            "sources": [
                {
                    "id": "35042889-f55b-4bc8-b1ef-93779d2d8163",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": [
                {
                    "id": "a5158bcc-e29e-4029-a61a-2ebaf4ecf141",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ]
        },
        "a5158bcc-e29e-4029-a61a-2ebaf4ecf141": {
            "sources": [
                {
                    "id": "cc01b36f-5b73-4962-8720-0837f02d5bcc",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": []
        },
        "106a5d9d-d2e3-4ba8-b5d1-0d80c7a0657f": {
            "sources": [],
            "targets": [
                {
                    "id": "55c3b37d-125b-416e-a024-f1d3ef5981ad",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ]
        },
        "155c01d3-b1de-4d80-b6d1-8a9bcb6b6d7c": {
            "sources": [
                {
                    "id": "b8ecd1b5-0236-4c42-9029-b2b29572711d",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": [
                {
                    "id": "dc03c89c-f462-43b2-b8d3-0f6d7689884f",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ]
        },
        "dc03c89c-f462-43b2-b8d3-0f6d7689884f": {
            "sources": [
                {
                    "id": "155c01d3-b1de-4d80-b6d1-8a9bcb6b6d7c",
                    "edge": {
                        "uiConfiguration": null
                    }
                }
            ],
            "targets": []
        }
    }
}